import { useState } from "react";
import { AlertTriangleIcon } from "lucide-react";
import { getBrowserName } from "@util/string";

interface BrowserCompatibilityWarningProps {
    onDismiss?: () => void;
}

export default function BrowserCompatibilityWarning({
    onDismiss,
}: BrowserCompatibilityWarningProps) {
    const [dismissed, setDismissed] = useState<boolean>(false);

    // Self-gate: only render for Arc. getBrowserName() returns
    // { name: "Arc" } when the userAgentData heuristic detects Arc.
    if (getBrowserName().name !== "Arc") return null;
    if (dismissed) return null;


    return (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg px-3 py-2.5 mb-4">
            <div className="flex items-start gap-2.5">
                <AlertTriangleIcon className="h-4 w-4 text-red-600 dark:text-red-300 flex-shrink-0 mt-0.5" />
                <p className="flex-1 text-xs text-red-800 dark:text-red-200 leading-relaxed">
                    For the best experience, please switch to <b>Google Chrome</b>, <b>Safari</b> or <b>Firefox</b>.
                    Some features may not work correctly on your current browser.
                </p>
            </div>
        </div>
    );
}
